import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${article.id}`}
      className="group flex flex-col sm:flex-row gap-4 p-4 rounded-lg bg-background-100 hover:bg-background-200 transition-all duration-300 cursor-pointer"
    >
      <div className="w-full sm:w-48 h-32 flex-shrink-0 rounded-md overflow-hidden">
        <img
          src={article.image}
          alt={article.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-2">
          <span className="text-xs text-accent-400 bg-accent-100/20 px-2 py-0.5 rounded-full whitespace-nowrap">
            {article.category}
          </span>
          <span className="text-xs text-foreground-500">{article.date}</span>
        </div>
        <h3 className="text-foreground-100 font-heading text-lg leading-snug mb-2 line-clamp-2 group-hover:text-primary-400 transition-colors">
          {article.title}
        </h3>
        <p className="text-foreground-500 text-sm leading-relaxed line-clamp-2">
          {article.excerpt}
        </p>
        <div className="flex items-center gap-1 mt-3 text-xs text-foreground-600">
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-user-line"></i>
          </div>
          <span>{article.author}</span>
        </div>
      </div>
    </Link>
  );
}